import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EquipesRoutingModule } from './equipes-routing.module';
import { EquipesComponent } from './equipes.component';
import { TableListModule } from '../../shared/components/table-list/table-list.module';
import { EquipeService } from 'src/app/shared/api/equipe.service';
import { FormEquipeComponent } from './form-equipe/form-equipe.component';
import { EditComponentModule } from '../../shared/components/edit-component/edit-component.module';
import { CardModule } from '../../shared/components/card/card.module';
import { TestesService } from 'src/app/shared/api/testes/testes-cliente.service';
import { ButtonModule } from '../../shared/components/button/button.module';
import { LicencasDisponiveisService } from 'src/app/shared/api/licencas/licencas-disponiveis.service';
import { AutocadastroModule } from '../autocadastro/autocadastro.module';
import { ContainerPadraoModule } from '../../shared/components/container-padrao/container-padrao.module';
import { LiberarLicencaEquipeModule } from './liberar-licenca-equipe/liberar-licenca-equipe.module';

@NgModule({
    declarations: [EquipesComponent, FormEquipeComponent],
    providers: [EquipeService, LicencasDisponiveisService, TestesService],
    imports: [
        CommonModule,
        EquipesRoutingModule,
        TableListModule,
        EditComponentModule,
        CardModule,
        ButtonModule,
        AutocadastroModule,
        ContainerPadraoModule,
        LiberarLicencaEquipeModule
    ]
})
export class EquipesModule {}
